import React from "react";
import { Box } from "@mui/material";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import { Gauge } from "@mui/x-charts/Gauge";
import { useNavigate } from "react-router-dom";
import Xfactor from "../Players/Xfactor";

const TrendingItem = ({ title, date, players }) => {
  const navigate = useNavigate();

  const handlePlayerClick = (playerId) => {
    navigate(`/player/${playerId}`);
  };

  return (
    <div className="trending-home">
      <div className="trending-home-header">
        <p className="trending-home-title">
          <WhatshotIcon sx={{ color: "#fd7f13", verticalAlign: "bottom" }} />{" "}
          {title}
        </p>
        <span style={{ opacity: "0.4" }}>{date}</span>
      </div>
      {players.map((player, index) => (
        <div
          key={index}
          className="trending-home-content"
          onClick={() => handlePlayerClick(player.id)}
          style={{ cursor: "pointer" }}
        >
          <div style={{ position: "relative", height: "200px" }}>
            <img
              className="trending-home-profile-image"
              src={player.profileImg}
              alt="profile"
            />
            <Xfactor score={player.xfactor} />
          </div>
          <div className="trending-home-content-text">
            <p style={{ color: "#7d9eff" }}>
              <span className="trending-home-highlight">
                <strong>{player.name}</strong>
              </span>
            </p>
            <div className="trending-home-content-text-stats">
              {player.stats.map((stat, statIndex) => (
                <p key={statIndex}>
                  <span className="trending-home-highlight">{stat.value}</span>{" "}
                  {stat.label}
                </p>
              ))}
            </div>
            <p>
              <span
                style={{
                  color: player.result === "Win" ? "#12eb72" : "#ff4545",
                }}
              >
                {player.result}
              </span>{" "}
              vs Opponent
            </p>
            <p>{player.event}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrendingItem;
